import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import { IContactUsReqData } from '../../types/api/contactUsApi';
import { useAppDispatch, useAppSelector } from '../../Hooks';
import { Loader } from '../common/Loader';
import { submitContactUsData } from '../../features/ContactUs';
import FeedbackForm from './FeedbackForm';
import { useTranslation } from 'react-i18next';
const ContactForm: React.FC = () => {
    const dispatch = useAppDispatch();
    const { contactUsLoader, status } = useAppSelector(state => state.contactUs);
    const [contactFormData, setContactFormData] = useState<IContactUsReqData>({ first_name: "", last_name: "", email: "", mobile_number: null, message: "" });

    const inputRef = useRef<any>(null);
    const itiRef = useRef<any>(null);

    const {t} = useTranslation();

    useEffect(() => {
        const input = inputRef.current;
        if (input) {
            itiRef.current = intlTelInput(input, {
                initialCountry: 'ly',
                separateDialCode: true,
            });

            return () => {
                // Cleanup: destroy the intl-tel-input instance
                itiRef.current?.destroy();
            };
        }
    }, [status]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setContactFormData({
            ...contactFormData,
            [name]: value,
        });

    }

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
console.log(itiRef.current,'itiRef.current');

        if (itiRef.current) {
            // Get the full phone number (including country code)
            const fullNumber = itiRef.current.telInput.value;
            const countryCode = itiRef.current.selectedCountryData.dialCode;
            const finalNumber = countryCode +  fullNumber;  
console.log(finalNumber,'finalNumber');

            // Validate the phone number
            if (isNaN(finalNumber)) {
                console.error('Invalid phone number');
                return;
            }

            // Dispatch the form data with the full phone number
            const updatedFormData = {
                ...contactFormData,
                mobile_number: Number(finalNumber),
            };
            console.log('Form Data:', updatedFormData);
            dispatch(submitContactUsData(updatedFormData)).then((res)=>{

                setContactFormData({ first_name: "", last_name: "", email: "", mobile_number: null, message: "" })
            }).catch((err)=>{
console.log(err,'err');

            })
        }
    };

    if (contactUsLoader) {
        return <Loader />;
    }

    return (
        <section className='contact-section'>
            <div className="container">
                <Row>
                    <Col md={12} lg={6}>
                        <div className="contact-img">
                            <img src={require('../../assets/images/contact-img.jpg')} alt="img" className="img-fluid"></img>
                        </div>
                    </Col>
                    <Col md={12} lg={6} >
                        <div className="contact-form">
                            <div className='form-heading'>
                                <h3 className='title'>{t('contactus.form_title')}</h3>
                                <p className='text'>{t('contactus.form_description')}</p>
                            </div>
                            <Form onSubmit={(e: React.FormEvent<HTMLFormElement>) => handleSubmit(e)}>
                                <Row>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <input type="text" placeholder={t('contactus.contact.first_name')} id="first_name" name="first_name" onChange={handleInputChange} />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <input type="text" placeholder={t('contactus.contact.last_name')} id="last_name" name="last_name" onChange={handleInputChange} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="form-group">
                                            <input type="email" placeholder={t('contactus.contact.email')} id="email" name="email" onChange={handleInputChange} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="form-group">
                                            <input type="text" ref={inputRef} id="mobile_code" className="form-control" placeholder={t('contactus.contact.phone_number')} name="mobile_number" onChange={handleInputChange} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="form-group">
                                            <textarea placeholder={t('contactus.contact.type_message')} id="message" name="message" onChange={handleInputChange}></textarea>
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <button type="submit" className="btn btn-gold" >{t('contactus.contact.button')}</button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Col>
                </Row>
                <Row  className='mt-5'>
            <FeedbackForm />

                </Row>
            </div>
        </section>  
    )
}
export default ContactForm;